import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { fontFamilyAll } from '../assets/commonComponents/COLORS';



function bannerCard({ isMobile, banner, bannerData }) {
    return (
        <Box sx={{ position: 'relative', width: '100%' }}>
            <Box component="img" src={banner} alt="Banner Image" sx={{ width: '100%', height: '700px', objectFit: 'cover' }} />
            
            <Box
                sx={{
                    position: 'absolute',
                    top: isMobile ? '35%' : '25%',
                    left: isMobile ? '5%' : '5%',
                    width: isMobile ? '90%' : '45%',
                    color: '#fff',
                    padding: isMobile ? 1 : 2,

                }}
            >
                <Typography variant={isMobile ? 'h5' : 'h5'} fontWeight="bold"  textAlign={"left"} fontFamily={fontFamilyAll}>
                    {bannerData[0]}
                </Typography>
                <Typography variant={isMobile ? 'h4' : 'h4'} fontWeight="bold" mt={2} fontFamily={fontFamilyAll}>
                    {bannerData[1]}
                </Typography>
                <Typography variant={isMobile ? 'body2' : 'body1'} mt={3} textAlign={"justify"} fontFamily={fontFamilyAll}>
                    {bannerData[2]}
                </Typography>
            </Box>
        </Box>
    )
}

export default bannerCard